// @flow
import type { StateType } from '../../reducers';
import type { SignUpIndividualStateType } from './reducer';

export const signUpIndividualContactMediumsStatusSelector = (state: StateType): SignUpIndividualStateType =>
  state.signUp.individual.isIndividualContactMediumsKo;
